import {headerStyles} from "@insite/content-library/Widgets/MyLists/MyListsHeader";


headerStyles.leftTopGridItem ={
    width: [11, 10, 8, 6, 6],
}

headerStyles.rightTopGridItem = {
    width: [1, 2, 4, 6, 6],
}